import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

/**
 * Rappel immédiat d'une vente quand l'application est ouverte.
 * La ligne durable est écrite côté serveur : ce toast ne marque rien comme lu
 * et reprend exactement le même texte (jamais de Coco sur une vente virement).
 */
export const SaleNotifications = () => {
  const { user } = useAuth();
  const { toast } = useToast();

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel("sale-notifications")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "purchases",
          filter: `seller_id=eq.${user.id}`,
        },
        async (payload) => {
          const sale = payload.new as {
            product_id: string | null;
            buyer_id: string;
            amount: number;
            transfer_intent_id: string | null;
          };

          const { data: product } = await supabase
            .from("products")
            .select("title")
            .eq("id", sale.product_id ?? "")
            .maybeSingle();

          const { data: buyer } = await supabase
            .from("profiles")
            .select("username, full_name")
            .eq("id", sale.buyer_id)
            .maybeSingle();

          const handle = buyer?.username
            ? `@${buyer.username}`
            : buyer?.full_name || "un membre";
          const productTitle = product?.title || "ton produit";

          if (sale.transfer_intent_id) {
            toast({
              title: `Vente confirmée : ${productTitle}`,
              description: `${handle} — virement confirmé.`,
              duration: 8000,
            });
            return;
          }

          toast({
            title: `${handle} a acheté ${productTitle}`,
            description: `${sale.amount} Coco.`,
            duration: 8000,
          });
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user, toast]);

  return null;
};
